(function () {
    'use strict';

    angular
        .module("skillsApp")
        .controller("AssetsDownloadDialogController", AssetsDownloadDialogController);

    function AssetsDownloadDialogController($uibModalInstance, userQuality) {
        var vm = this;

        vm.userQualityId = userQuality.id;
        vm.assets = userQuality.exemption.exemptionAssets;

        vm.close = close;

        function close() {
            $uibModalInstance.dismiss('cancel');
        }
    }

})();